import messages from './loader-translations';

export default {
    name: 'loader',
    i18n: {
        messages,
    },
    props: {
        show: {
            type: Boolean,
        },
        title: {
            type: String,
        },
        message: {
            type: String,
        },
        isStatic: {
            type: Boolean,
        },
        hasDismiss: {
            type: Boolean,
        },
        isError: {
            type: Boolean,
        },
    },
    methods: {
        dismiss: function () {
            this.$emit('loaded');
        },
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/loader/loader.js